// extracted by mini-css-extract-plugin
module.exports = {"button":"button__3CoW2"};